import { usePWA } from '@/hooks/usePWA'

export const PWAStatus = () => {
    const { isOnline } = usePWA()

    return (
        <div className="fixed bottom-4 right-4 z-50">
            {!isOnline && (
                <div className="bg-orange-500 text-white px-3 py-2 rounded-lg shadow-lg text-sm">
                    📱 Mode hors ligne, veuillez vérifier votre connexion internet.
                </div>
            )}
        </div>
    )
}
